import { cn } from "@/lib/utils";
import { X } from "./ui/icons/x";
import { YouTube } from "./ui/icons/youtube";
import { Instagram } from "./ui/icons/instagram";
import { Facebook } from "./ui/icons/facebook";

interface FooterProps {
	className?: string;
}

const Footer = ({ className }: FooterProps) => {
	const currentYear = new Date().getFullYear();

	const socialLinks = [
		{
			name: "Facebook",
			href: "https://facebook.com/coffitivity",
			icon: <Facebook className="w-5 h-5" />,
		},
		{
			name: "X (Twitter)",
			href: "https://x.com/coffitivity",
			icon: <X className="w-5 h-5" />,
		},
		{
			name: "YouTube",
			href: "https://www.youtube.com/@CoffitivityOfficial",
			icon: <YouTube className="w-5 h-5" />,
		},
		{
			name: "Instagram",
			href: "https://instagram.com/coffitivityofficial",
			icon: <Instagram className="w-5 h-5" />,
		},
	];

	return (
		<footer
			className={cn(
				"mt-16 ml-[-1rem] sm:ml-[-2rem] mb-[-1rem] sm:mb-[-2rem] w-[calc(100%+2rem)] sm:w-[calc(100%+4rem)] py-8 border-t border-border/50 bg-muted/20 md:rounded-b-lg",
				className,
			)}
		>
			<div className="max-w-4xl mx-auto px-4">
				{/* Social Links */}
				<div className="flex justify-center mb-6">
					<div className="flex items-center gap-3 sm:gap-4">
						{socialLinks.map((social) => (
							<a
								key={social.name}
								href={social.href}
								target="_blank"
								rel="noopener noreferrer"
								className="text-muted-foreground hover:text-primary transition-all duration-200 p-2.5 hover:bg-accent rounded-full hover:scale-110 group"
								aria-label={`Follow us on ${social.name}`}
							>
								<div className="transform transition-transform group-hover:scale-110">
									{social.icon}
								</div>
							</a>
						))}
					</div>
				</div>

				{/* Copyright */}
				<div className="text-center space-y-2">
					<p className="text-sm text-muted-foreground font-medium">
						&copy; 2013-{currentYear} Coffitivity. All rights reserved.
					</p>
					<p className="text-xs text-foreground">
						Brewed by{" "}
						<a
							href="https://equalsons.com"
							target="_blank"
							rel="noopener noreferrer"
							className="hover:text-primary transition-colors underline-offset-2 hover:underline font-medium"
						>
							Equal Sons
						</a>
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
